import './Footer.css';
import { Link } from 'react-router-dom';
import { FaEnvelope, FaPhoneAlt } from "react-icons/fa";

const Footer = () => {
    return (
        <footer className="footer-bar">
          <div className="footer-section">
            <h3>Company</h3>
            <ul>
              <li>
                <Link to="/about" style={{ color: 'white', textDecoration: 'none' }}>
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/terms-and-conditions" style={{ color: 'white', textDecoration: 'none' }}>
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" style={{ color: 'white', textDecoration: 'none' }}>
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/contact" style={{ color: 'white', textDecoration: 'none' }}>
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
          <div className="footer-section">
            <h3>Our Services</h3>
            <ul>
              <li>Dry Cleaning</li>
              <li>Shoe Cleaning</li>
              <li>Steam Ironing</li>
              <li>Premium Laundry</li>
            </ul>
          </div>
          <div className="footer-section">
            <h3>Our Presence</h3>
            <p>Address: B-10, Ground Floor G-02, Sector-2, Noida, UP, 201301</p>
            <p><FaEnvelope style={{ marginRight: '10px' }} />
            support@neatnclean.in</p>
            <p><FaPhoneAlt style={{ marginRight: '10px' }} />
            +919654335152</p>
          </div>
        </footer>
      )
  };
  
  export default Footer;